import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./track-page.module.css";
import "../App.css";
import { Collapse } from "reactstrap";

const getCargoType = (value) => {
  if (value <= 300) return "Light Cargo";
  else if (value <= 600) return "Light Heavy Cargo";
  else if (value > 600) return "Heavy Cargo";
  return "";
};

function CargoInfo({ data, isOpen }) {
  console.log(data.waybill_info);
  return (
    <Collapse isOpen={isOpen}>
      <p className={styles.main_info}>Item Information</p>
      <Container className={styles.main_info_container}>
        <Col md={6} sm={12}>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Item Type: </p>
              </Col>
              <Col>
                <p className="fw-normal">
                  {data?.waybill_info?.item.itemtype?.name}
                </p>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Item Name: </p>
              </Col>
              <Col>
                <p className="fw-normal">
                  {data?.waybill_info?.item?.itemname}
                </p>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Measurement: (m3): </p>
              </Col>
              <Col>
                <p className="fw-normal">{data?.waybill_info?.item?.volume}</p>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Item Value: </p>
              </Col>
              <Col>
                <p className="fw-normal">
                  {data?.waybill_info?.item?.item_value}
                </p>
              </Col>
            </Row>
          </Col>
        </Col>
        <Col md={6} sm={12}>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Shipment Type: </p>
              </Col>
              <Col>
                <p className="fw-normal">
                  {data?.waybill_info?.shipment_type?.name}
                </p>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Payment Method: </p>
              </Col>
              <Col>
                <p className="fw-normal">
                  {data?.waybill_info?.cost?.paymentType?.name}
                </p>
              </Col>
            </Row>
          </Col>

          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Quantity: </p>
              </Col>
              <Col>
                <p className="fw-normal">{data?.waybill_info?.item?.qty}</p>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Gross Weight (Kg): </p>
              </Col>
              <Col>
                <p className="fw-normal">{data?.waybill_info?.item?.weight}</p>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Remark: </p>
              </Col>
              <Col className="fw-normal">
                <p>{data?.waybill_info?.item?.remark}</p>
              </Col>
            </Row>
          </Col>
        </Col>
      </Container>
    </Collapse>
  );
}

export default CargoInfo;
